'use client'
import { useId } from 'react'

type Props = {
  reviewScore: number
  reviewCount?: number | null
  className?: string
  starClassName?: string
}

export const ReviewStars = ({
  reviewScore,
  reviewCount,
  className = '',
  starClassName = '',
}: Props) => {
  const id = useId()

  const stars = Array.from({ length: 5 }, (_, i) => {
    const fillLevel = Math.min(Math.max(reviewScore - i, 0), 1)
    const uniqueId = `grad-${id}-${i}`

    return (
      <svg
        key={i}
        className={`c-review-stars__star ${starClassName}`}
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none">
        <defs>
          <linearGradient id={uniqueId}>
            <stop offset={`${fillLevel * 100}%`} stopColor="black" />
            <stop offset={`${fillLevel * 100}%`} stopColor="rgba(0,0,0,0)" />
          </linearGradient>
        </defs>
        <path
          d="M7.55835 4.27368L7.67456 4.50903L7.93433 4.54712L11.4333 5.05396L8.89819 7.52759L8.71069 7.71118L8.75464 7.96997L9.35327 11.4592L6.22144 9.81372L5.98901 9.69067L5.75562 9.81274L2.62183 11.4563L3.22144 7.96997L3.26636 7.71118L3.07788 7.52759L0.542725 5.05396L4.04565 4.54712L4.3064 4.50903L4.42261 4.27368L5.98804 1.10181L7.55835 4.27368Z"
          fill={`url(#${uniqueId})`}
          stroke="black"
          strokeOpacity={reviewScore ? 1 : 0.55}
          strokeWidth={1}
        />
      </svg>
    )
  })

  return (
    <>
      <div
        role="img"
        aria-label={`${reviewScore.toFixed(1)} stars`}
        className={`c-review-stars ${className}`}>
        {stars}
        {typeof reviewCount === 'number' && (
          <span className="c-review-stars__review-count">{`(${reviewCount})`}</span>
        )}
      </div>
    </>
  )
}

export default ReviewStars
